import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class ComprobantesItemStatus extends Component {

  get config() {
    const { status } = this.props;

    let variant = 'success';
    let icon = 'circle';

    switch (status) {
      case 'cancelling':
          variant = 'warning';
          icon = 'circle';
        break;

      case 'cancelled':
          variant = 'danger';
          icon = 'circle';
        break;

      default:
        break;
    }

    return {
      icon,
      variant
    }
  }

  render() {
    const { icon, variant } = this.config;

    return (
      <span className={ `badge-rounded text-${variant}` }>
        <FontAwesomeIcon icon={ ['fas', icon] } />
      </span>
    )
  }
}

export default ComprobantesItemStatus;